//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        resident: {
            default: null
        },
        property: {
            default: null
        },
        building: {
            default: null
        },
        unit: {
            default: null
        }

    },
    data: function data() {
        return {
            filterKey: '',
            loading: true,
            requests: [],
            closedRequests: [],
            listOfObjects: [],
            pagination: { last_page: '', current_page: '', url: '', next_page_url: '' },
            isLoading: false,
            searchLoading: false,
            loadMore: true,
            search: '',
            update: true
        };
    },

    computed: {
        filteredRequests: function filteredRequests() {

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.requests;
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        },
        filteredClosedRequests: function filteredClosedRequests() {

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.closedRequests;
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        }
    },
    created: function created() {
        var _this = this;

        Event.$on('get-requests', function () {
            return _this.refreshData();
        });
        Event.$on('refresh-service', function (response, type) {
            return _this.updateData(response, type);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('get-requests');
        Event.$off('refresh-service');
    },

    watch: {
        unit: function unit(newVal, oldVal) {
            if (newVal != oldVal) {
                this.requests = [];
                this.closedRequests = [];
                this.refreshData();
            }
        },
        building: function building(newVal, oldVal) {
            if (newVal != oldVal) {
                this.requests = [];
                this.closedRequests = [];
                this.refreshData();
            }
        },
        property: function property(newVal, oldVal) {
            if (newVal != oldVal) {
                this.requests = [];
                this.closedRequests = [];
                this.refreshData();
            }
        },
        resident: function resident(newVal, oldVal) {
            if (newVal != oldVal) {
                this.requests = [];
                this.closedRequests = [];
                this.refreshData();
            }
        }
    },
    methods: {
        refreshData: function refreshData() {
            var _this2 = this;

            this.isLoading = true;
            var $el = this;
            $el.search = this.pagination.url ? '&search=' + $el.filterKey : '?search=' + $el.filterKey;
            var url = $el.resident ? 'residents/' + $el.resident.id : $el.property ? 'properties/' + $el.property.id : $el.building ? 'buildings/' + $el.building.id : $el.unit ? 'units/' + $el.unit : $el.person ? 'person/' + el.person.id : '';

            axios.get('/prototype/' + url + '/serviceRequests' + this.pagination.url + $el.search).then(function (response) {
                if (response.data.data) {
                    _this2.isLoading = false;
                    //Get current page
                    _this2.pagination.current_page = response.data.current_page;
                    //Get last page
                    _this2.pagination.last_page = response.data.last_page;
                    _this2.pagination.next_page_url = response.data.next_page_url;
                    var payLoad = [];
                    var payLoadClosed = [];
                    if (_this2.pagination.current_page > 1 || _this2.search) {
                        $el.listOfObjects = Object.keys(response.data.data).map(function (key) {
                            return response.data.data[key];
                        });
                    } else {
                        $el.listOfObjects = response.data.data;
                    }
                    $el.listOfObjects.forEach(function (element) {
                        if ($el.property || $el.building || $el.unit) {
                            // Get location and reporter
                            element.reporterType = '';
                            element.reporterName = '';

                            if (element.reporter) {
                                element.reporterType = element.reporter && element.reporter.person ? 'Resident' : 'User';
                                if (element.reporter.person) {
                                    element.reporterName = element.reporter.person.first_name + ' ' + element.reporter.person.last_name;
                                } else if (element.reporter) {
                                    element.reporterName = element.reporter.first_name + ' ' + element.reporter.last_name;
                                }
                            }

                            switch (element.reportable_type) {
                                case 'App\\Unit':
                                    element.reportableType = 'Unit: ' + element.reportable.name;
                                    break;
                                case 'App\\Building':
                                    element.reportableType = 'Building: ' + element.reportable.name;
                                    break;
                                case 'App\\Property':
                                    element.reportableType = 'Property: ' + element.reportable.name;
                                    break;
                            }
                        }

                        if (element.completed_at) {
                            payLoadClosed.push(element);
                        } else {
                            payLoad.push(element);
                        }
                    });

                    $el.requests = _this2.requests.concat(payLoad);
                    $el.closedRequests = _this2.closedRequests.concat(payLoadClosed);
                    $el.loading = false;
                    $el.loadMore = true;
                    $el.searchLoading = false;
                }
            });
        },
        updateData: function updateData(response, type) {
            var $el = this;
            var element = response.data;
            var index = this.requests.findIndex(function (item) {
                return response.data.id === item.id;
            });
            if ($el.property) {
                // Get location and reporter
                element.reporterType = '';
                element.reporterName = '';

                if (element.reporter) {
                    element.reporterType = element.reporter && element.reporter.person ? 'Resident' : 'User';
                    if (element.reporter.person) {
                        element.reporterName = element.reporter.person.first_name + ' ' + element.reporter.person.last_name;
                    } else if (element.reporter) {
                        element.reporterName = element.reporter.first_name + ' ' + element.reporter.last_name;
                    }
                }

                switch (element.reportable_type) {
                    case 'App\\Unit':
                        element.reportableType = 'Unit: ' + element.reportable.name;
                        break;
                    case 'App\\Building':
                        element.reportableType = 'Building: ' + element.reportable.name;
                        break;
                    case 'App\\Property':
                        element.reportableType = 'Property: ' + element.reportable.name;
                        break;
                }
            }
            if (type === 'close') {
                this.closedRequests.push(element);
                this.requests.splice(index, 1);
            } else if (type === 'open') {
                this.requests.splice(index, 1, element);
            } else {
                this.requests.unshift(element);
            }
        },
        loadMoreProducts: function loadMoreProducts() {
            //check if last page is greater than the current page
            if (this.pagination.last_page > this.pagination.current_page) {
                this.pagination.url = this.pagination.next_page_url;
                this.refreshData();
            } else {
                this.$noty.info("There are no more data in the database", {
                    closeWith: ["click", "button"]
                });
            }
        },


        getUser: function getUser(user_id_assigned) {

            if (user_id_assigned == null) {
                return;
            }

            axios.get('/prototype/users/' + user_id_assigned).then(function (response) {
                if (!response.data) {
                    return 'None';
                }

                if (response.data) {
                    return response.data;
                }
            });
        },

        addNew: function addNew() {
            Event.$emit('add-service-request');
        },

        viewDetail: function viewDetail(ServiceId) {
            Event.$emit('view-service', ServiceId);
        },
        searchServiceRequest: function searchServiceRequest() {
            this.requests = [], this.closedRequests = [], this.loadMore = false;
            this.loading = true;
            this.searchLoading = true;
            this.pagination.url = '';
            this.refreshData();
        }
    },
    mounted: function mounted() {
        this.refreshData();
        var self = this;
        Event.$on('show-property-tab-service-request', function () {
            self.update = false;
            setTimeout(function () {
                self.update = true;
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/ServiceRequestList.vue
// module id = MeV0
// module chunks = 0 1